import { useState } from "react";
import EmployeesList from "./EmployeesList";
import PermissionList from "./PermissionList";
import RolesList from "./RolesList";

const AccessControlPermission = () => {
    const [activeTab, setActiveTab] = useState('employee');

    return (
        <>
          <div className="title-text">
            <h3 className="h3-title">Access Control</h3>
             
            </div>
         <p className="sub">Assign roles and permissions. Manage by person, by role, or by permission.</p>
          <div className="tabs role-tabs">
                <button className={`tab ${activeTab==='employee' ? 'on' : ''}`} data-tab="people" onClick={() => setActiveTab('employee')}>People</button>
                <button className={`tab ${activeTab==='roles' ? 'on' : ''}`} data-tab="roles" onClick={() => setActiveTab('roles')}>Roles</button>
                <button className={`tab ${activeTab==='permission' ? 'on' : ''}`} data-tab="perms" onClick={() => setActiveTab('permission')}>Permissions</button>
            </div>

{activeTab === 'employee' && (
            <EmployeesList></EmployeesList>
            )}

            {activeTab === 'roles' && (

            <RolesList></RolesList>
 )}

            {activeTab === 'permission' && (
            <PermissionList></PermissionList>
             )}

         
        </>
    )
}

export default AccessControlPermission;